import Vue from 'vue';
import Vuex from 'vuex';
import cacheApi from '../api/cache-api';
import accountApi from '../api/account-api';
import hrApi from '../api/hr-api';

Vue.use(Vuex);

const getDefaultUserInfo = () => {
  return {
    language: 'korean',
    level: '',
    name: '',
    notice_read_flag: true,
    office: {},
    office_user_no: '',
    user_id: '',
    user_no: '',
    position: '',
    platform_icon_display_flag: false,
    nodes: [],
  };
};

const getDefaultOfficeInfo = () => {
  return {
    office: {},
    config: {},
  };
};

const getDefaultOfficeCurrent = () => {
  return {
    id: '',
    office_id: '',
    type: '',
    contract_no: '',
    is_license_target_office: false,
    inside_mail_flag: false,
    is_managed: false,
    is_custom_logo: false,
    office_name: '',
    show_platform_menu: '',
    logo_img_cfg: '',
  };
};

const initialState = () => {
  return {
    /**
     language: "korean"
     level:"admin"
     name:"마커스"
     notice_read_flag:true
     office: {
      office_no: "1994", office_type: "domain", office_id: "gabiaholdings.com", show_platform_menu: "N"
     }
     office_id: "gabiaholdings.com"
     office_no: "1994"
     office_type: "domain"
     show_platform_menu: "N"
     office_user_no: "1007093"
     roles:[
      {service: "hr", type: "admin"}
      {service: "bill", type: "admin"}
     ]
     user_id: "marcus"
     user_no: "5612980"
     */
    userInfo: getDefaultUserInfo(),
    officeInfo: getDefaultOfficeInfo(),
    officeCurrent: getDefaultOfficeCurrent(),
  };
};

const getters = {
  isShowPlatformMenu(state) {
    if (!state.userInfo) return false;
    return state.userInfo.platform_icon_display_flag;

    // if (state.userInfo.level === 'admin') {
    //   return true;
    // }
    //
    // if (state.userInfo.office.show_platform_menu === 'Y') {
    //   return true;
    // }
    //
    // if (!state.userInfo.roles) {
    //   return false;
    // }
    //
    // return state.userInfo.roles.some((role) => {
    //   return (
    //     (role.service === 'hr' && role.type === 'admin') ||
    //     (role.service === 'erp' && role.type === 'admin') ||
    //     (role.service === 'hr_pay' && role.type === 'admin') ||
    //     (role.service === 'hr_contract' && role.type === 'admin') ||
    //     (role.service === 'bill' && role.type === 'admin') ||
    //     (role.service === 'bill' && role.type === 'user')
    //   );
    // });
  },
  isV3(state) {
    return state.officeCurrent.is_license_target_office;
  },

  isAdmin(state) {
    return state.userInfo.level === 'admin';
  },
};

const mutations = {
  setUserInfo(state, userInfo) {
    state.userInfo = userInfo;
  },
  setOfficeInfo(state, officeInfo) {
    state.officeInfo = officeInfo;
  },

  setOfficeCurrent(state, officeCurrent) {
    state.officeCurrent = officeCurrent;
  },
};

const actions = {
  async loadUserInfo({ commit }) {
    try {
      const userInfo = await fetchUserData();
      commit('setUserInfo', userInfo);
    } catch (error) {
      console.error('Failed to load user info:', error);
      commit('setUserInfo', getDefaultUserInfo());
    }
  },
  async loadOfficeInfo({ commit }) {
    return new Promise((resolve) => {
      commit('setOfficeInfo', getDefaultOfficeInfo());

      cacheApi
        .loadOfficeConfigCache()
        .then((apiResponse) => {
          const { data } = apiResponse.data;
          commit('setOfficeInfo', data);
        })
        .finally(() => {
          resolve();
        });
    });
  },

  async loadOfficeCurrent({ commit }) {
    return new Promise((resolve) => {
      commit('setOfficeCurrent', getDefaultOfficeCurrent());
      cacheApi
        .loadOfficeCurrent()
        .then((apiResponse) => {
          const { data } = apiResponse.data;
          commit('setOfficeCurrent', data);
        })
        .finally(() => {
          resolve();
        });
    });
  },

  async updateNoticeStateInfo() {
    await cacheApi.updateNoticeState();
  },
};

async function fetchUserData() {
  const [userResponse, accountResponse] = await Promise.allSettled([
    cacheApi.loadUserCache(),
    accountApi.loadAccountInfo(),
  ]);

  let userInfo = {};

  // User 정보 처리
  if (userResponse.status === 'fulfilled') {
    userInfo = { ...userInfo, ...userResponse.value.data?.data };
  }

  // Account 정보 처리 / 직위와 조직을 얻기 위함
  if (accountResponse.status === 'fulfilled') {
    const accountData = accountResponse.value.data.data;
    userInfo.nodes = accountData.nodes;

    if (accountData.position_no) {
      const position = await fetchPositionInfo(accountData.position_no);
      if (position) userInfo.position = position;
    }
  }

  return userInfo;
}

async function fetchPositionInfo(positionNo) {
  try {
    const response = await hrApi.getPosition(positionNo);
    const positionData = response.data?.data;
    return positionData?.[0]?.code_content || null;
  } catch (error) {
    console.warn('Failed to fetch position info:', error);
    return null;
  }
}

export default {
  namespaced: true,
  state: initialState,
  mutations,
  actions,
  getters,
  strict: process.env.NODE_ENV !== 'production',
};
